import e from"react";const t=({children:n,shouldRender:l,fallbackComponent:o})=>l?e.createElement(e.Fragment,null,n):o||null;export{t as ConditionalFragment};
